export default {"src":"/_next/static/media/google-play.033b12cf.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};